import type { InquiryOffer } from "@/types/camping";

export function inquiryFitLabel(offer: InquiryOffer): string {
  if (offer.status === "impossible") return "Nicht möglich";
  if (offer.status === "possible") return "Möglich";
  if (offer.kind === "relocation") return "Möglich mit Umzug";
  if (offer.kind === "category_change") return "Andere Kategorie";
  if (offer.kind === "category_change_relocation") return "Umzug und andere Kategorie";
  return "Möglich mit Änderung";
}

function inquiryFitClass(offer: InquiryOffer): string {
  if (offer.status === "impossible") {
    return "bg-status-red/15 text-status-red border-status-red/30";
  }
  if (offer.status === "possible") {
    return "bg-status-green/15 text-status-green border-status-green/30";
  }
  return "bg-status-orange/15 text-status-orange border-status-orange/30";
}

export function InquiryFitBadge({ offer }: { offer: InquiryOffer | null | undefined }) {
  if (!offer?.status) return null;
  const changes = (offer.changes ?? []).filter((line) => line.trim());
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium leading-tight ${inquiryFitClass(offer)}`}
      title={changes.length ? changes.join("\n") : inquiryFitLabel(offer)}
    >
      {inquiryFitLabel(offer)}
    </span>
  );
}
